import React from "react";
import { Navigate } from "react-router-dom";

const RemissionGuideAdd = React.lazy(
  () => import("../../../../../components/remission-guide/components/add/page"),
);
const RemissionGuideIssued = React.lazy(
  () => import("../../../../../components/remission-guide/components/list/page"),
);

export const remissionGuidesRoutes = [
  {
    path: "add",
    element: <RemissionGuideAdd />,
  },
  {
    path: "issued",
    element: <RemissionGuideIssued />,
  },
  {
    path: "",
    element: <Navigate replace to="/sri/remission-guides/issued" />,
  },
];
